module.exports = __webpack_public_path__ + "static/media/IMG_3321.ed832020.jpg";